<template>
    <div class="mt-3">
        <label>{{ trans('general.module.report.update_popup.step.details.choose_hydration_time') }}</label>
        <custom-radio
            v-model="hydration"
            :items="hydrationDesigner"
            type="grid"/>
    </div>
</template>

<script>
import CustomRadio from "../../../../theme/molecules/CustomRadio.vue";
import {HYDRATION_TYPES_DESIGNER} from "../../../../services/Defaults";
import GeneralReportForm from "../GeneralReportForm.vue";

export default {
    name: "Hydration",
    extends: GeneralReportForm,
    components: {CustomRadio},
    data() {
        return {
            model: {
                ...this.value,
                time: null,
            },

            hydration: {value: ''},
        };
    },
    watch: {
        model: {
            handler: function (value) {
                this.internalUpdate = true;
                this.$emit('input', value);
            },
            deep: true
        },
        hydration: function (item) {
            this.model.time = item.value;
        }
    },
    computed: {
        hydrationDesigner() {
            return this.getSelectItems(
                Object.entries(HYDRATION_TYPES_DESIGNER),
                'general.module.hydration'
            )
        },
    },
};
</script>
